import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const KeywordsIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M8.63633 2.5C7.42268 2.5 6.23628 2.85989 5.22717 3.53416C4.21806 4.20843 3.43155 5.16679 2.9671 6.28806C2.50266 7.40932 2.38114 8.64314 2.61791 9.83347C2.85468 11.0238 3.43911 12.1172 4.29729 12.9754C5.15547 13.8335 6.24886 14.418 7.43919 14.6547C8.62952 14.8915 9.86334 14.77 10.9846 14.3056C12.1059 13.8411 13.0642 13.0546 13.7385 12.0455C14.4128 11.0364 14.7727 9.84998 14.7727 8.63633C14.7726 7.0089 14.126 5.44817 12.9753 4.2974C11.8245 3.14664 10.2638 2.5001 8.63633 2.5V2.5Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
    <path
      d="M13.2144 13.2146L17.4999 17.5001"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M6.65854 11.1717H7.5724L8.59863 7.58371H8.63858L9.66231 11.1717H10.5762L12.0194 6.05811H11.0231L10.1018 9.81843H10.0568L9.07054 6.05811H8.16417L7.18039 9.81593H7.13295L6.21159 6.05811H5.21533L6.65854 11.1717Z"
      fill="currentColor"
    />
  </SvgIcon>
);
